import { Injectable } from '@angular/core';
import { AddPaymentViewModel, ImaginePayRefundViewModel, PaymentService, ScheduledPaymentViewModel } from 'data';
import { BaseWrapperService } from './base-wrapper.service';
import { SessionStorageService } from '../session-storage.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PaymentWrapperService extends BaseWrapperService {
  constructor(private service: PaymentService, protected sessionStorageService: SessionStorageService) {
    super();
  }

  apiV1PaymentAddPost(addPaymentViewModel: AddPaymentViewModel) {
    return this.service.apiV1PaymentAddPost(this.getDataSetId(), addPaymentViewModel);
  }

  apiV1PaymentConfigPost() {
    return this.service.apiV1PaymentConfigPost(this.getDataSetId());
  }

  apiV1PaymentGetPaymentIdRefnoPost(patientId: string, refno: string) {
    return this.service.apiV1PaymentGetPaymentIdRefnoPost(patientId, refno, this.getDataSetId());
  }

  apiV1PaymentAddRefundPost(refund: ImaginePayRefundViewModel) {
    return this.service.apiV1PaymentAddRefundPost(this.getDataSetId(), refund);
  }

  apiV1PaymentGetScheduledIdPost(patientId: string) {
    return this.service.apiV1PaymentGetScheduledIdPost(patientId, this.getDataSetId());
  }

  apiV1PaymentSetScheduledIdPost(patientId: string, scheduleModel: ScheduledPaymentViewModel) {
    return this.service.apiV1PaymentSetScheduledIdPost(patientId, this.getDataSetId(), scheduleModel);
  }

  apiV1PaymentDeleteScheduledIdDelete(patientId: string) {
    return this.service.apiV1PaymentDeleteScheduledIdDelete(patientId, this.getDataSetId());
  }

  apiV1PaymentPatientPaymentsIdPost(patientId: string) {
    return this.service.apiV1PaymentPatientPaymentsIdPost(patientId, this.getDataSetId());
  }

  apiV1PaymentUnappliedUpdateIdPost(id: string, requestBody): Observable<any> {
    return this.service.apiV1PaymentUnappliedUpdateIdPost(id, this.getDataSetId(), requestBody);
  }
  
}
